// extracted by mini-css-extract-plugin
module.exports = {"textContainer":"GK7RVb","clamp":"fwrG6M"};